import { useEffect, useRef, useState } from "react";
import { nFormatter } from "../../utils";

export default function SpeedOMeter(props) {
  const { value, width, min, max, label } = props;
  const [previousValue, setPreviousValue] = useState(0);
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    let x = (2 / 3) * width;
    let y = (2 / 3) * width;
    let radius = width / 2;

    let ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    let minRad = 0.75 * Math.PI;
    let maxRad = 2.25 * Math.PI;
    let normalizedValue = 0;
    if (value === undefined) {
      if (previousValue > max) normalizedValue = 1;
      else if (previousValue < min) normalizedValue = 0;
      else {
        normalizedValue = previousValue / (max - min);
      }
    } else {
      if (value > max) normalizedValue = 1;
      else if (value < min) normalizedValue = 0;
      else {
        normalizedValue = value / (max - min);
      }
      setPreviousValue(value);
    }
    let valueRad = (maxRad - minRad) * normalizedValue + minRad;
    let toolTipWidth = 100;
    let toolTipHeight = 60;
    let toolTipArrowHeight = 30;

    // Create gradient
    let grd = ctx.createLinearGradient(x - radius, 0, x - radius + width, 0);
    grd.addColorStop(0, "#3F5EFB");
    grd.addColorStop(1, "#FC466B");

    let grd2 = ctx.createLinearGradient(0, 0, toolTipWidth, 0);
    grd2.addColorStop(0, "white");
    grd2.addColorStop(1, "#D8D8D8");

    //background
    ctx.beginPath();
    ctx.arc(x, y, radius, minRad, maxRad);
    ctx.lineWidth = 10;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#eee";
    ctx.stroke();

    //foreground
    ctx.beginPath();
    ctx.arc(x, y, radius, minRad, valueRad);
    ctx.lineWidth = 8;
    ctx.lineCap = "round";
    ctx.strokeStyle = grd;
    ctx.stroke();

    // ctx.beginPath();
    // ctx.translate(x, y);
    // ctx.rotate(valueRad);
    // ctx.rect(radius + toolTipArrowHeight, -toolTipWidth/2, toolTipHeight, toolTipWidth);
    // ctx.moveTo(radius + toolTipArrowHeight, -toolTipWidth/2);
    // ctx.lineTo(radius, 0);
    // ctx.lineTo(radius + toolTipArrowHeight, toolTipWidth/2);
    // ctx.fillStyle = grd2;
    // ctx.fill();

    // ctx.rotate(0.5*Math.PI);
    // ctx.textAlign="center";
    // ctx.font="30px Helvetica";
    // ctx.fillStyle = "#155D9B";
    // ctx.fillText(text, 0, -radius - toolTipArrowHeight - (toolTipHeight/4));


    // draw needle

    ctx.translate(x,y);
    ctx.rotate(valueRad+0.05);
    ctx.beginPath();
    ctx.moveTo(0,-5);
    ctx.lineTo(radius*1.05,0);
    ctx.lineTo(0,5);
    ctx.fillStyle='red';
    ctx.fill();
    ctx.rotate(-valueRad-0.05);
    ctx.translate(-x,-y);
    ctx.beginPath();
    ctx.fillStyle='#eee';
    // ctx.shadowColor = "#998";
    // ctx.shadowBlur = 10;
    // ctx.shadowOffsetX = 0;
    // ctx.shadowOffsetY = 0;
    ctx.arc(x,y,20,0,Math.PI*2);
    ctx.fill();

    ctx.rotate(0);
    ctx.textAlign = "center";
    ctx.font = "12px Helvetica";
    ctx.fillStyle = previousValue < value ? "#FC466B" : "#155D9B";
    let newLabel = label.split('\b');
    for(let i=0;i<newLabel.length;i++) {
      ctx.fillText(newLabel[i], x, y * 2+(i*15)-5);
    }

    ctx.rotate(0);
    ctx.textAlign = "center";
    ctx.font = "16px Helvetica";
    ctx.fillStyle = previousValue < value ? "#FC466B" : "#155D9B";
    const valueText = nFormatter(value, 1);
    ctx.fillText(valueText, x, y * 1.1);

  }, [props]);

  return (
      <div>
        <canvas ref={canvasRef} />
      </div>
  );
}


